import React from "react"
import { Window, View, Text, Toggle, Grid, Col } from "react-ame-components"

export class ToggleExample extends React.Component {
  state = {
    checked_1: true,
    checked_2: false,
    checked_3: true,
    checked_4: false,
  }

  handleChangeToggle = () => {
    const { condicao } = this.state
    const newCondition = !condicao
    this.setState({ condicao: newCondition })
  }

  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Toggle[/color]
                </Text>
                <Text>Este componente serve para exibir um Toggle</Text>
                <View margin="small">
                  <View marginTop="small">
                    <Toggle
                      onChange={e => this.setState({ checked_1: e.checked })}
                      checked={this.state.checked_1}
                    />
                  </View>
                </View>
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
